const accountRoutes = {
  index: {
    path: 'index.account',
    url: 'compte',
  },
  home: {
    path: 'index.account.home',
    url: '/accueil',
  },
  edit: {
    path: 'index.account.edit',
    url: '/modifier',
  },
  new: {
    path: 'index.account.new',
    url: '/nouveau',
  },
  consult: {
    path: 'index.account.accounts',
    url: '/tous',
  },
}

export default accountRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/account/routes.js